<template>
  <div class="page--container">
    <div class="page--section">
      <el-row :gutter="10">
        <el-col :md="{ span: 8, offset: 0 }" :sm="{ span: 24, offset: 0 }">
          <div class="module__stat">
            <div v-if="inProgress" class="module__big-number">{{ inProgress }}</div>
            <div v-else class="module__big-number">0</div>
            <div v-if="inProgress == 1" class="module__little-text">{{ $t('trainingStatInProgressSingle') }}</div>
            <div v-else class="module__little-text">{{ $t('trainingStatInProgresssMultiple') }}</div>
          </div>
        </el-col>
        <el-col :md="8">
          <div class="module__stat">
            <div v-if="completed" class="module__big-number">{{ completed }} <span class="small-heading">of</span> {{
              courses }}</div>
            <div v-else class="module__big-number">0 <span class="small-heading">of</span> {{ courses }}</div>
            <div class="module__little-text">{{ $t('trainingStatCompleted') }}</div>
          </div>
        </el-col>
        <el-col :md="8">
          <div class="module__stat">
            <div v-if="certificates" class="module__big-number">{{ certificates }}</div>
            <div v-else class="module__big-number">0</div>
            <div v-if="certificates == 1" class="module__little-text">{{ $t('trainingStatCertificatesSingle') }}</div>
            <div v-else class="module__little-text">{{ $t('trainingStatCertificatesMultiple') }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrainingStatisticsBar',
  props: {
    certificates: Number,
    completed: Number,
    inProgress: Number,
    courses: Number,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/base/_variables.scss';
@import 'element-theme-chalk/src/mixins/mixins.scss';

.module {



  &__stat {
    background: #FAFAFA;
    min-height: 92px;
    padding: 20px;

    @include res(sm) {
      margin-bottom: 12px;
    }

    @include res(xs) {
      margin-bottom: 12px;
    }
  }

  &__big-number {
    font-family: $font-family-headings;
    font-size: 36px;
    text-align: center;
    font-weight: bold;

    .small-heading {
      font-size: 80%;
    }
  }

  &__little-text {
    font-size: 18px;
    text-align: center;
  }
}
</style>
